// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_4i-2";
export var blackBorderOnHover = "_4i-7";
export var cell = "_4i-6";
export var cellContainer = "_4i-3";
export var checked = "_4i-8";
export var disabled = "_4i-5";
export var featuredIconCellContainer = "_4i-9";
export var featuredIconTextContainer = "_4i-b";
export var featuredIconWrapper = "_4i-a";
export var noBorder = "_4i-c";
export var orangeSelectedRow = "_b4-3";
export var overflowableText = "_4i-0";
export var overflowableTextContainer = "_4i-1";
export var row = "_4k-0";
export var rowCheckboxCell = "_4i-4";
export var selectableTable = "_b4-2";